import React from 'react';
import { useViewport } from '~/utils/viewport-provider';

export const ViewportText = ({
  text,
  as = 'p',
  className = '',
}: {
  text?: ViewportText;
  as?: TextElement;
  className?: string;
}) => {
  const { isMobile } = useViewport();
  if (!text) return null;
  const T = as;

  return (
    <T
      className={`text-reset ${className}`}
      style={{
        lineHeight: isMobile
          ? text.mobile_line_height
          : text.desktop_line_height,
        fontSize: isMobile
          ? `${text.mobile_text_size}rem`
          : `${text.desktop_text_size}rem`,
      }}
      dangerouslySetInnerHTML={{
        __html: isMobile ? text.mobile : text.desktop,
      }}
    />
  );
};
